import { useEffect, useMemo, useState } from 'react'

import { useNotifications } from 'app/application/application'
import { formatNumber } from 'app/common/presentation/format'
import { useAnalytics } from 'app/dashbaord/application'
import { Conversions } from 'app/dashbaord/types/conversion'

import { ProgressBar } from 'components'

import Tile, { TileContentProps } from './Tile'
import styles from './Tile.module.scss'

type EventCount = {
  count: number
  name: string
}

const Conversion = ({ days, translate }: TileContentProps) => {
  const { fetchConversions } = useAnalytics()
  const { createNotification, te } = useNotifications()

  const [conversions, setConversions] = useState<Conversions>()

  useEffect(() => {
    void fetchConversions(days).then((result) =>
      result.ok
        ? setConversions(result.val)
        : createNotification({
            message: result.val.message,
            title: te(`http.${result.val.code}`),
            type: 'error',
          }),
    )
  }, [createNotification, days, fetchConversions, te])

  const totalConversionEvents = useMemo(
    () => (conversions ? Object.values(conversions).reduce((acc, current) => acc + current, 0) : 0),
    [conversions],
  )

  const eventStatistics = useMemo(
    () =>
      conversions
        ? Object.entries(conversions)
            .reduce((acc, [eventName, count]) => {
              const existingEventCount = acc.find((eventCount) => eventCount.name === eventName)

              if (existingEventCount) {
                existingEventCount.count += count
              } else {
                acc.push({
                  name: eventName,
                  count,
                })
              }

              return acc
            }, [] as EventCount[])
            .sort((a, b) => b.count - a.count)
            .slice(0, 5)
        : [],
    [conversions],
  )

  return (
    <Tile className={styles.conversion} days={days} tileKey="conversion" translate={translate}>
      <div className={styles.events}>
        <div className={styles.total}>
          <div>{translate('conversion.total')}</div>
          <div>{formatNumber(totalConversionEvents)}</div>
        </div>
        {eventStatistics.map((eventStatistic, index) => (
          <div className={styles.event} key={index}>
            <div>
              <div>{eventStatistic.name}</div>
              <div>{formatNumber(eventStatistic.count / totalConversionEvents, 'percent')}</div>
            </div>
            <ProgressBar percentage={eventStatistic.count / totalConversionEvents} />
          </div>
        ))}
      </div>
    </Tile>
  )
}

export default Conversion
